<template>
  <div class="headerBox">
    <HeaderBanner></HeaderBanner>
    <div class="centerBox">
      <div class="logo pointer"
           @click="GoHome"><img src="@/assets/images/logo.png" style="height: 40px;"/></div>
      <div class="menuBox">
        <ul class="menu-list xy-center jf-start">
          <li v-for="(item, index) in umenuData"
              :key="index"
              :class="{'active': item.index === $route.path}"
              @click="goMenu(item.path)"
              >
            <span v-if="item.name === '教育智库'">
              <el-dropdown>
                <span class="font-size16 f-c-232a3a FW400">{{item.name}}</span>
                <el-dropdown-menu class="wrap-header-dropdown" slot="dropdown">
                  <div class="dropdown-body">
                    <el-dropdown-item
                        @click.native="$router.push(children.path)"
                        v-for="(children) in item.children"
                        :key="children.path"
                        :class="{'f-c-root bold': children.path === $route.path}"
                    >
                      {{children.name}}
                    </el-dropdown-item>
                  </div>
                </el-dropdown-menu>
              </el-dropdown>
            </span>
            <span v-else>{{ item.name }}</span>
          </li>
        </ul>
      </div>
      <div class="infoBox xy-center" :class="{'al-s-center':!loginStatus}">
        <img
            class="userBox-memberCenter pointer mr-30"
            :src="require('@/assets/images/memberCenter.png')"
            @click="jumpPaymentCenter(false)"
        />
        <div class="userBox" v-if="loginStatus == true">
          <!-- <div class="message">
            <span><i class="el-icon-bell"></i>消息
              <a href="javascript:;">(0)</a>
            </span>
          </div> -->
          <el-dropdown placement="bottom-start">
            <div class="userAvatar">
              <el-avatar :src="$store.getters.userAvatar"></el-avatar>
              <span class="userName" :title="$store.getters.userName">{{ $store.getters.userName }}</span>
            </div>

            <el-dropdown-menu class="userDrop"
                              slot="dropdown">
              <el-dropdown-item @click.native="handleUserIndex">个人中心</el-dropdown-item>
              <el-dropdown-item @click.native="handleHelp">操作手册</el-dropdown-item>
              <el-dropdown-item @click.native="handleLoginOut">退出</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="loginBox"
             v-else>
          <!-- <div v-if="!this.$route.meta.isLogin"> -->
          <div>
            <!-- <el-button type="primary" size="mini" @click="GoLogin()">登录</el-button>
            <el-button type="primary" size="mini">注册</el-button> -->
            <a href="javascript:;"
               @click="GoLogin()">登录</a>
            <i>/</i>
            <a href="javascript:;"
               @click="GoRigster()">注册</a>
          </div>
          <!-- <div v-else>
            <el-button type="primary"
                       size="mini"
                       @click="GoHome">返回首页</el-button>
          </div> -->
        </div>
      </div>
    </div>
    <img @mousedown="startDrag"
         v-if="isShowBot"
         title="AI问答"
         ref="draggable"
         :style="{ position: 'fixed',left: position.x + 'px', top: position.y + 'px' }"
         class="bot-container"
         src="@/assets/images/bot.gif"
         alt="bot"
         @click="handleAiJump"
    />
    <div class="fixToolBox">
      <ul>
        <li v-for="(item,index) in toolData"
            :key="index"
            :id="'toolData_' + item.id"
            @click="toolHandle(item.id)">
          <i :class="'iconfont ' + item.classname"></i>
          <!-- <h5>{{ item.title }}</h5> -->
          <div class="hoverSpace"
               v-if="item.content.length > 0">
            <h6>{{ item.title }}</h6>
            <p :class="item.content.length === 1 ? 'one': ''"
               v-for="(subitem,subindex) in item.content"
               :key="subindex">{{ subitem.content }}
              <i v-if="subitem.icon != ''"
                 :class="'iconfont ' + subitem.icon"></i>
            </p>
          </div>
        </li>
        <!-- <li><i class="iconfont icon-dianhua"></i><h6></h6></li>
        <li><i class="iconfont icon-touxiang"></i><h6></h6></li>
        <li><i class="iconfont icon-huidaodingbu"></i><h6></h6></li> -->
      </ul>
    </div>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import { getUrlKey } from '@/utils/tool'
import { BindOrg, LoginOutForbBit } from '@/http/api/common'
import { setCer } from '@/utils/auth'
import jumpPaymentCenter from "@/views/member/src/mixins/jumpPaymentCenter";
import HeaderBanner from "@/components/Common/HeaderBanner";
export default ({
  name: "HeaderBox",
  components: { HeaderBanner },
  mixins: [ jumpPaymentCenter ],
  data () {
    return {
      toolData: [
        {
          id: 1,
          title: '在线咨询',
          classname: 'icon-zixun',
          content: [
            {
              content: "专属经理在线解答",
              icon: "icon-icon-test"
            }
          ]
        },
        {
          id: 2,
          title: '电话咨询',
          classname: 'icon-dianhua',
          content: [
            {
              content: "023-63658989（业务支持）",
              icon: ""
            }

          ]
        },
        {
          id: 3,
          title: '个人中心',
          classname: 'icon-touxiang',
          content: [
            {
              content: "我的教研",
              icon: ""
            }]
        },
        {
          id: 4,
          title: '返回顶部',
          classname: 'icon-huidaodingbu',
          content: []
        }
      ],
      umenuData: [
        {
          name: "首页",
          path: "/",
          index: '/',
        },
        {
          name: "教研资源",
          path: "/collection",
          index: '/collection',
        },
        {
          name: "写作中心",
          path: "/writingCenter/intelligentTopic",
          index: '/writingCenter/intelligentTopic',
        },
        {
          name: "校内文苑",
          path: "/wenYuan",
          index: '/wenYuan',
        },
        {
          name: "教育智库",
          path: "/activity/list",
          index: '/activity/list',
          children: [
            {
              name: "教研活动",
              path: "/activity/list",
              index: '/activity/list',
            },
            {
              name: "学校专区",
              path: "/school",
              index: '/school',
            },
            {
              name: "好老师智库",
              path: "/teacherGood/teacherGoodIndex",
              index: '/teacherGood/teacherGoodIndex',
            },
          ]
        },
      ],
      avatar: this.$store.state.user.userInfo.photoPath,
      position: { x: window.innerWidth - 200, y: window.innerHeight - 500}, // 元素的位置
      isDragging: false, // 是否正在拖动
      offset: { x: 0, y: 0 }, // 鼠标点击位置与元素左上角的偏移
      isClickAllowed: true,
      timer: null,
    }
  },
  created () {
    // 是否登录
    if (this.userInfo !== '' && this.userInfo !== null && this.userInfo !== undefined) {
      //this.loginStatus = true
      this.$store.commit('common/SET_LOGINSTATUS', true)  
    }
  },
  mounted () {
    // 监听页面滚动事件
    // this.umActive = this.$route.path
    // 获取登录信息
    // console.log(this.userInfo.status)
    if (this.userInfo.status != true) {
      const ticket = getUrlKey('ticket')
      if (ticket != '' && ticket != null) {
        const self = this
        this.$store.dispatch('user/login', { ticket: ticket }).then(res => {
          if (res.statusCode == 200) {
            if (res.extras.apiStatusCode === 1000) {
              //self.loginStatus = true
              self.$store.commit('common/SET_LOGINSTATUS', true)  
              // self.$message.error(res.extras.message)
              // 显示提示绑定机构
              if (res.data.isRedirectBind) {
                self.$confirm("检测您的所属机构为[" + res.data.organInfo.organizationName + "]，是否绑定？", "系统提示", {
                  confirmButtonText: "立即绑定",
                  cancelButtonText: "取消",
                  type: "success"
                }).then(() => {
                  // 绑定机构
                  BindOrg().then(res => {
                    if (res.statusCode == 200) {
                      if (res.extras.apiStatusCode == 1000) {
                        self.$message({
                          type: "success",
                          message: "绑定成功！"
                        })

                        // 更新认证状态
                        let cerObj = self.$store.state.user.isCertified
                        cerObj.ibo = 1
                        self.$store.commit('user/SET_ISCERTIFIED', cerObj)
                        setCer(JSON.stringify(cerObj))
                        self.$router.replace({ query: {} });
                        // 更新存储
                      } else {
                        self.$message.error("绑定失败，可移步到个人中心再次尝试")
                      }
                    } else {
                      self.$message.error(res.extras.message)
                    }
                  })
                }).catch(() => {
                  // 取消绑定
                })
              } else {
                self.$router.replace({ query: {} });
              }
            } else if (res.extras.apiStatusCode === 1001) {
              // console.log('111',res)
              self.$message.error(res.extras.message)
              LoginOutForbBit({ ticket: ticket }).then(res => {
                console.log(res)
              })
            }
          }
        })
      }
    }
  },
  computed: {
    ...mapGetters([
      'userInfo',
      'loginStatus'
    ]),
    isShowBot() {
      let flag = (/writingCenter|writingDetail|collection-readUp/g.test(this.$route.name))
      return true;
    },
  },
  beforeDestroy() {
    // 组件销毁时移除事件监听，防止内存泄漏
    window.removeEventListener("mousemove", this.onDrag);
    window.removeEventListener("mouseup", this.stopDrag);
    window.removeEventListener("resize", this.onResize);
  },
  methods: {
    handleAiJump() {
      if(!this.isClickAllowed){
        this.$router.push({
          path: "/writingCenter/ai-questionsAndAnswers"
        })
      }
      this.timer = null;
    },
    // 开始拖动
    startDrag(event) {
      this.isClickAllowed = false;
      if(this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(()=>{
        this.isClickAllowed = true;
      },100)
      event.preventDefault();
      this.isDragging = true;
      const rect = this.$refs.draggable.getBoundingClientRect();
      this.offset.x = event.clientX - rect.left;
      this.offset.y = event.clientY - rect.top;

      // 监听鼠标移动和松开事件
      window.addEventListener("mousemove", this.onDrag);
      window.addEventListener("mouseup", this.stopDrag);
    },
    // 拖动中
    onDrag(event) {
      if (this.isDragging) {
        // 计算新位置
        let newX = event.clientX - this.offset.x;
        let newY = event.clientY - this.offset.y;

        // 限制元素在浏览器可视区域内
        const maxX = window.innerWidth - this.$refs.draggable.offsetWidth;
        const maxY = window.innerHeight - this.$refs.draggable.offsetHeight;

        newX = Math.max(0, Math.min(newX, maxX));
        newY = Math.max(0, Math.min(newY, maxY));

        // 更新元素位置
        this.position.x = newX;
        this.position.y = newY;
      }
    },
    // 停止拖动
    stopDrag() {
      this.isDragging = false;

      // 移除事件监听
      window.removeEventListener("mousemove", this.onDrag);
      window.removeEventListener("mouseup", this.stopDrag);

      // 更新固定位置
      this.position = {
        x: this.position.x,
        y: this.position.y,
      };
      // this.isDragging = false;
      //
      // // 移除事件监听
      // window.removeEventListener("mousemove", this.onDrag);
      // window.removeEventListener("mouseup", this.stopDrag);
      //
      // // 设置固定位置
      // this.fixedPosition = this.percentToPixel(this.position);
    },
    goMenu (path) {
      this.$router.push(path)
    },
    GoLogin () {
      // this.$router.push('/login')
      // 跳转登录
      window.location.href = this.$loginBack
      // login({ ticket: '7464afc8ffe6472fa0a33f820d6d2b23' }).then(res => {
      //   console.log(res)
      // })
    },
    GoRigster () {
      window.location.href = this.$registBack
    },
    GoHome () {
      this.$router.push("/")
    },
    //个人中心
    handleUserIndex () {
      this.$router.push("/user")
    },
    //退出
    async handleLoginOut () {
      const self = this
      this.$store.dispatch('user/logout').then(res => {
        if (res.statusCode === 200) {
          if (res.extras.apiStatusCode === 1001) {
            self.$message({
              type: 'error',
              message: res.extras.message,
              duration: 5000
            })
          } else {
            //self.loginStatus = false
            self.$store.commit('common/SET_LOGINSTATUS', false)  
            self.$router.push('/')
          }
        }
      })
    },
    // 客服菜单
    toolHandle (id) {
      switch (id) {
        case 1:
          // document.getElementById("nb_icon_inner_wrap").click()
          break;
        case 3:
          this.$router.push("/user")
          break;
        case 4:
          document.body.scrollTop = document.documentElement.scrollTop = 0
          break;
      }
    },
    handleHelp () {
      window.open('https://scn2k8s07fy7.feishu.cn/wiki/YziPwv97iiPgCfkHSoLcjpPEnre?from=from_copylink', "_blank")
    }
  }
})
</script>

<style lang="scss" scoped>
@import "@/assets/css/components/header.scss";
</style>